import React, { useEffect } from "react";
import { useActions } from "tiny-atom/react/hooks";
import { GlobalComponentContextProvider } from "../context/GlobalComponentsContext";
import { RoutingContextProvider } from "../context/RoutingContext";

export default function App({ children }) {
  const { auth } = useActions();

  useEffect(() => {
    auth();
  }, [auth]);

  return (
    <GlobalComponentContextProvider>
      <RoutingContextProvider>{children}</RoutingContextProvider>
    </GlobalComponentContextProvider>
  );
}
